import { SidebarIcon } from "../../../components";

const getPfizerCopayIVSidebarItems = (t) => [
  {
    title: t("application_form_editor.pfizer.copay.iv.patient.sidebar"),
    // JSON renderer's SectionPart emits id `enrollment-form-${sectionName}` — must match the FormJson section names.
    href: "#enrollment-form-patient",
    key: "patient",
    validationFields: ["patient"],
    icon: SidebarIcon
  },
  {
    title: t("application_form_editor.pfizer.copay.iv.practice.sidebar"),
    href: "#enrollment-form-facility",
    key: "practice",
    validationFields: ["facility"],
    icon: SidebarIcon
  },
  {
    title: t("application_form_editor.pfizer.copay.iv.consent.sidebar"),
    href: "#enrollment-form-eligibility_questionnaire",
    key: "consent",
    validationFields: ["eligibilityQuestionnaire"],
    icon: SidebarIcon
  }
];

export default getPfizerCopayIVSidebarItems;
